export const EDVISOR_LOGIN_SETSTATE = "EDVISOR_LOGIN_SETSTATE";
export const EDVISOR_LOGIN_AUTHENTICATION = "EDVISOR_LOGIN_AUTHENTICATION";
export const EDVISOR_LOGIN_GETMENUDETAILS = "EDVISOR_LOGIN_GETMENUDETAILS";
export const EDVISOR_LOGIN_PAGERESET = "EDVISOR_LOGIN_PAGERESET";
export const EDVISOR_FORGOT_PASSWORD = "EDVISOR_FORGOT_PASSWORD";
export const EDVISOR_VERIFY_OTP = "EDVISOR_VERIFY_OTP"; 
export const EDVISOR_RESET_PASSWORD = "EDVISOR_RESET_PASSWORD";